exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-cb191a2a] .el-tabs__content{height:calc(100% - 55px);overflow-y:auto}", ""]);

// exports
